// Legacy parity: `toLocaleDateString() toLocaleTimeString()`,
// empty string when null/invalid — deliberately NOT the shared formatDate
// ('not set' + fixed en-GB format) so the port renders identically.
export const formatParkedTimestamp = (value: unknown): string => {
  if (typeof value !== 'string' && typeof value !== 'number') return '';
  if (value === '') return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
};

/** 'NO_MATCHING_PAYOUT_ACCOUNT' → 'NO MATCHING PAYOUT ACCOUNT' */
export const formatReasonLabel = (reason: string): string => reason.replace(/_/g, ' ');
